export const postMessage = (type: string) => {
	if (typeof window == undefined || !window?.ReactNativeWebView) {
		return;
	} else {
		window.ReactNativeWebView?.postMessage(JSON.stringify({ type: type }));
	}
};
